<template>
  <sidebar-layout>
    <h2>{{ i18n.t('events.show.event_full') }}</h2>
    <span v-html="explanatoryText" />
    <div v-if="eventStatus.allowWaitlistSignup" class="attend-event-form">
      <one-click-info />
      <rsvp-form :attending-status="waitingListStatus" />
    </div>
  </sidebar-layout>
</template>

<script>
import { mapState } from 'vuex'
import OneClickInfo from './one-click-info'
import RsvpForm from './form'
import SidebarLayout from '@/campaign-action-shared/sidebar-layout'
import { WAITING_LIST } from './attending-statuses'

export default {
  components: { OneClickInfo, RsvpForm, SidebarLayout },

  data() {
    return {
      waitingListStatus: WAITING_LIST
    }
  },

  computed: {
    ...mapState(['eventStatus']),

    explanatoryText() {
      if (this.eventStatus.allowWaitlistSignup) {
        return this.i18n.t('events.show.event_full_accompanying_text_html')
      } else {
        return this.i18n.t('events.show.event_full_no_waitlist_text_html')
      }
    }
  }
}
</script>
